import { gql } from 'graphql-request';
import { Nullable, UserWithToken, WithData } from '@ygoargentina/sdk/api/api.types';
import { getGraphQLQueryClient } from './query-client';

export type AssetFile = {
  key: string;
  name: string;
  url: string;
};

export const getBackgroundAssets = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<AssetFile[]>>(gql`
    query backgroundAssets {
      data: backgroundAssets {
        key
        name
        url
      }
    }
  `);
